import React from "react";
import Thankyou from "../../components/thankyou/Thankyou";

interface ThankyouContainerInterface {}

const ThankyouContainer: React.FC<
  ThankyouContainerInterface
> = () => {
  return <Thankyou />;
};

export default ThankyouContainer;
